import { inject, Injectable, signal } from '@angular/core'
import { signalPersistence } from '@mos/client/shared/storage/signal-persistence'
import { LocalStorageStrategy } from '@mos/client/shared/storage/strategies/local-storage.strategy'

interface ActivityProps {
	lastStoryActivity: Date | null
}

@Injectable({ providedIn: 'root' })
export class ActivityRepository {
	// Forces LocalStorageStrategy (skipping Capacitor Preferences on mobile) to prevent too many writes -
	// this data isn't important enough to warrant the extra native storage overhead.
	private readonly storageStrategy = inject(LocalStorageStrategy)
	private readonly state = signal<ActivityProps>({ lastStoryActivity: null })

	constructor() {
		signalPersistence<ActivityProps>({
			key: 'mos-activity',
			storage: this.storageStrategy,
			read: () => this.state(),
			write: (stored) => this.state.set(stored),
			revive: (stored) => ({
				...stored,
				lastStoryActivity: stored.lastStoryActivity ? new Date(stored.lastStoryActivity) : null,
			}),
		})
	}

	getLastStoryActivity(): Date | null {
		return this.state().lastStoryActivity
	}

	refreshLastStoryActivity() {
		this.state.update((state) => ({ ...state, lastStoryActivity: new Date() }))
	}
}
